import { BigNumber } from '@frontend/numeric';

import { numberAsBigNumberOrUndefined } from '../number';

export const trimToDecimal = (value: number | undefined, decimals: number) => {
  return numberAsBigNumberOrUndefined(value)?.decimalPlaces(decimals, BigNumber.ROUND_DOWN).toNumber();
};
